import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Box, AppBar, Toolbar, Typography, Button, Stack } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BuildIcon from "@mui/icons-material/Build";
import UploadIcon from "@mui/icons-material/Upload";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
// Pages
import CsvUpload from "./pages/CsvUpload";
import Analysis from "./pages/Analysis";
import Dashboard from "./pages/Dashboard";
import ReviewJoinsMulti from "./components/ReviewJoinsMulti";
import TableRoles from "./components/TableRoles";
import Admin from "./pages/Admin";

function App() {
  return (
    <Router>
      <Box sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
        {/* Top Navigation Bar */}
        <AppBar position="static" sx={{ bgcolor: "#1e1e1e", boxShadow: 2 }}>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            {/* Logo */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <DashboardIcon sx={{ fontSize: 28, color: "#ff9800" }} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  fontSize: 20,
                  color: "#fff",
                  letterSpacing: 0.5,
                }}
              >
                AIdatalooks
              </Typography>
            </Box>
            {/* Navigation Links */}
            <Stack direction="row" spacing={1}>
              <Button
                color="inherit"
                href="/"
                startIcon={<UploadIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 14,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                }}
              >
                Upload CSV
              </Button>
              <Button
                color="inherit"
                href="/analysis"
                startIcon={<BuildIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 14,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                }}
              >
                Report Builder
              </Button>
              <Button
                color="inherit"
                href="/review-joins"
                startIcon={<AccountTreeIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 14,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                }}
              >
                Review Joins
              </Button>
              <Button
                color="inherit"
                href="/table-roles"
                startIcon={<FactCheckIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 14,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                }}
              >
                Table Roles
              </Button>
              <Button
                color="inherit"
                href="/admin"
                startIcon={<AdminPanelSettingsIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 14,
                  "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                }}
              >
                Administration
              </Button>
              <Button
                color="inherit"
                href="/dashboard"
                startIcon={<DashboardIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 14,
                  bgcolor: "rgba(255,152,0,0.2)",
                  borderRadius: 1,
                  "&:hover": { bgcolor: "rgba(255,152,0,0.3)" },
                }}
              >
                Enterprise Dashboard
              </Button>
            </Stack>
          </Toolbar>
        </AppBar>
        {/* Page Content */}
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <Routes>
            <Route path="/" element={<CsvUpload />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/review-joins" element={<ReviewJoinsMulti />} />
            <Route path="/table-roles" element={<TableRoles connectionId="oracle_free" />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Box>
      </Box>
    </Router>
  );
}
export default App;
